import type { Log, NewLogInput, NewStatusChangeInput, StatusChangeLog } from '@/db/domain/models'
import type { Db } from '@/lib/db'

export interface ServiceActivityAdapter {
  listNotesByServiceId(serviceId: string): Log[]
  listStatusChangesByServiceId(serviceId: string): StatusChangeLog[]
  appendLog(serviceId: string, input: NewLogInput): Log
  appendStatusChange(serviceId: string, input: NewStatusChangeInput): StatusChangeLog
}

export function createCalloutActivityAdapter(db: Db): ServiceActivityAdapter {
  return {
    listNotesByServiceId(serviceId: string) {
      return db.notesCollection
        .toArray
        .filter((note: Log) => note.serviceId === serviceId)
    },
    listStatusChangesByServiceId(serviceId: string) {
      return db.statusChangesCollection
        .toArray
        .filter((statusChange: StatusChangeLog) => statusChange.serviceId === serviceId)
    },
    appendLog(serviceId: string, input: NewLogInput) {
      return db.appendLog(serviceId, input)
    },
    appendStatusChange(serviceId: string, input: NewStatusChangeInput) {
      return db.appendStatusChange(serviceId, input)
    },
  }
}

export function createSessionActivityAdapter(db: Db): ServiceActivityAdapter {
  return {
    listNotesByServiceId(serviceId: string) {
      return db.sessionNotesCollection
        .toArray
        .filter((note: Log) => note.serviceId === serviceId)
    },
    listStatusChangesByServiceId(serviceId: string) {
      return db.sessionStatusChangesCollection
        .toArray
        .filter((statusChange: StatusChangeLog) => statusChange.serviceId === serviceId)
    },
    appendLog(serviceId: string, input: NewLogInput) {
      return db.appendSessionLog(serviceId, input)
    },
    appendStatusChange(serviceId: string, input: NewStatusChangeInput) {
      return db.appendSessionStatusChange(serviceId, input)
    },
  }
}
